import { render, staticRenderFns } from "./selfDepartPositiveRate.vue?vue&type=template&id=85d01460"
import script from "./selfDepartPositiveRate.vue?vue&type=script&lang=js"
export * from "./selfDepartPositiveRate.vue?vue&type=script&lang=js"
import style0 from "./selfDepartPositiveRate.vue?vue&type=style&index=0&id=85d01460&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports